module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductConfiguratorAddToCart":{"addToCartPrice":{"priceText":"Naše cena od:","priceWithTax":"vč. DPH","priceWithoutTax":"bez DPH"},"fillRequiredParams":"Nejdříve vyberte parametry produktu"}}}')
  delete Component.options._Ctor
}
